import { Component } from "@angular/core";
import { BaseModalComponent } from "@modals/base-modal/base-modal.component";

@Component({
  selector: "app-contact-support-modal",
  templateUrl: "./contact-support-modal.component.html",
  standalone: false,
})
export class ContactSupportModalComponent extends BaseModalComponent<
  ContactSupportModalComponent,
  null
> {
  readonly supportEmail = "tcohdvhde@tengizchevroil.com";
  readonly adminEmails = [
    "talogcoor@tengizchevroil.com",
    "tcotrcoor@tengizchevroil.com",
  ];
}
